import { createSlice } from '@reduxjs/toolkit';

const initialData = {
  isLocationScope: true,
  selectedOne: null,
  isAllSelected: false,

  isLocationSelected: [],
  isSpecificLocationSelected: [],
  isMachineSelected: [],

  selectedLocations: [],
  selectedSpecificLocations: [],
  selectedMachines: [],

  displaySelectBox: false,

  isApplied: false,
  inputTemp: 0,
  isF: false,
  scheduleList: [
    {
      start: { date: null, time: null },
      end: { date: null, time: null },
      inputTemp: null,
      isF: null,
    },
  ],
};

const initialState = {
  instantHeat: initialData,
  snowSensor: initialData,
  optionalConstant: initialData,
  heatingSchedule: initialData,
  windFactor: initialData,
  ats: initialData,
  shutOff: initialData,
  fanOnly: initialData,
};

const masterControlSelectByLocationSlice = createSlice({
  name: 'masterControlSelectByLocation',
  initialState,
  reducers: {
    // make selected result to display
    handleResetSelectedOneByLocation: (state) => {
      state.instantHeat.selectedOne = null;
      state.snowSensor.selectedOne = null;
      state.optionalConstant.selectedOne = null;
      state.heatingSchedule.selectedOne = null;
      state.windFactor.selectedOne = null;
      state.ats.selectedOne = null;
      state.shutOff.selectedOne = null;
      state.fanOnly.selectedOne = null;
    },
    handleSelectedOneByLocation: (state, action) => {
      state[action.payload.controller].selectedOne = action.payload.selectedOne;
    },
    // select all locations at once
    handleSelectAllByLocation: (state, action) => {
      // ALL = true
      state[action.payload.controller].isAllSelected = action.payload.status;
      // all location = true
    },
    // select a location
    handleLocationSelectByLocation: (state, action) => {
      state[action.payload.controller].isLocationSelected = action.payload.arr;
    },
    // select a specific location
    handleSpecificLocationSelectByLocation: (state, action) => {
      state[action.payload.controller].isSpecificLocationSelected =
        action.payload.arr;
    },
    // select an individual machine
    handleMachineSelectByLocation: (state, action) => {
      state[action.payload.controller].isMachineSelected = action.payload.arr;
    },
    // select machine by selected locations
    handleMachineSelectAllByLocation: (state, action) => {
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.machineIdx] = true;
    },

    // Add selected location name
    handleAddLocationsByLocation: (state, action) => {
      state[action.payload.controller].selectedLocations = action.payload.arr;
    },
    // Add selected specific location name
    handleAddSpecificLocationsByLocation: (state, action) => {
      state[action.payload.controller].selectedSpecificLocations =
        action.payload.arr;
    },
    // Add selected machine name
    handleAddMachinesByLocation: (state, action) => {
      state[action.payload.controller].selectedMachines = action.payload.arr;
    },
    // `status` lets a row be turned back off. It defaults to true so existing
    // callers that only ever select keep working.
    handleMachineSelectAltByLocation: (state, action) => {
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.machineIdx] = action.payload.status ?? true;
    },
    handleMachineSelectWithSpecLocationAltByLocation: (state, action) => {
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.specLocationIdx][action.payload.machineIdx] =
        action.payload.status ?? true;
    },

    handleResetAllSelectByLocation: (state, action) => {
      return { ...initialState };
    },
    // display box toggler
    handleDisplaySelectBoxByLocation: (state, action) => {
      state[action.payload.controller].displaySelectBox =
        !state.displaySelectBox;
    },
    // for what??? no idea...
    handleDisplaySelectBoxWithActionByLocation: (state, action) => {
      state.displaySelectBox = action.payload;
    },
    // instantHeat
    handleApplyWithTempByLocation: (state, action) => {
      // change apply button state depends on controller name
      state[action.payload.controller].isApplied =
        !state[action.payload.controller].isApplied;
      // change input temp. depends on controller name
      state[action.payload.controller].inputTemp = action.payload.temp;
    },
    handleSetScheduleListByLocation: (state, action) => {
      state.heatingSchedule.scheduleList[action.payload.index] = {
        start: action.payload.start,

        end: action.payload.end,
        inputTemp: action.payload.inputTemp,
        isF: action.payload.isF,
      };

      state.heatingSchedule.scheduleList[action.payload.index + 1] = {
        start: { date: null, time: null },
        end: { date: null, time: null },
        inputTemp: null,
        isF: null,
      };
    },
  },
});

export default masterControlSelectByLocationSlice;
export const selectMCByLocation = (state) =>
  state.masterControlSelectByLocation;
export const {
  handleSelectAllByLocation,
  handleSelectedOneByLocation,
  handleLocationSelectByLocation,
  handleSpecificLocationSelectByLocation,
  handleMachineSelectByLocation,
  handleAddLocationsByLocation,
  handleAddSpecificLocationsByLocation,
  handleAddMachinesByLocation,
  handleMachineSelectAllByLocation,
  handleResetAllSelectByLocation,
  handleDisplaySelectBoxByLocation,
  handleDisplaySelectBoxWithActionByLocation,
  handleMachineSelectAltByLocation,
  handleMachineSelectWithSpecLocationAltByLocation,

  handleApplyWithTempByLocation,
  handleSetScheduleByLocation,
  handleResetSelectedOneByLocation,
} = masterControlSelectByLocationSlice.actions;
